import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { toURL } from '.'
import MomentTimelinePage from '../../components/pages/MomentTimelinePage'
import UpdateMomentPage from '../../components/pages/UpdateMomentPage'
import CreateMomentPage from '../../components/pages/CreateMomentPage'

export const AppRoutes = {
  main: 'main',
  createMoment: 'createMoment',
  updateMoment: 'updateMoment',
}

const AppPaths = {
  main: '/',
  createMoment: '/moment/create',
  updateMoment: '/moment/update/:id',
}

export function toPath(route, params) {
  switch (route) {
    case AppRoutes.createMoment:
      return AppPaths.createMoment
    case AppRoutes.updateMoment:
      return AppPaths.updateMoment.replace(':id', params.id)
    case AppRoutes.main:
    default:
      return AppPaths.main
  }
}

export function toRoute(pathname) {
  const url = toURL(pathname)
  if (url.path[0] === 'moment' && url.path[1] === 'create')
    return AppRoutes.createMoment
  if (url.path[0] === 'moment' && url.path[1] === 'update')
    return AppRoutes.updateMoment
  else return AppRoutes.main
}

const AppRouter = ({ userId }) => (
  <React.Fragment>
    <Switch>
      <Route
        path={AppPaths.createMoment}
        render={props => <CreateMomentPage userId={userId} />}
      />
      <Route
        path={AppPaths.updateMoment}
        render={({ match: { params } }) => (
          <UpdateMomentPage userId={userId} momentId={params.id} />
        )}
      />
      <Route
        path={AppPaths.main}
        render={() => <MomentTimelinePage userId={userId} />}
      />
    </Switch>
  </React.Fragment>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/modules/router/AppRouter.js